import template from './riskInsuranceRequirements.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    requirements: '<',
    contacts: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, helperService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.requirements = ctrl.requirements || {};
        ctrl.contacts = ctrl.contacts || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.saveRiskInsuranceRequirementsApplicants = (applicants) => {
        if (applicants) {
          ctrl.requirements.applicants = applicants;
          ctrl.saveRiskInsuranceRequirements();
        }
      };

      ctrl.saveRiskInsuranceRequirements = _.debounce(() => {
        ctrl.onFinished({ requirements: ctrl.requirements });
      }, 2000);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
